import { Button } from "../ui/button";
import { StepHeader, NavButtons, AiLoader } from "../common";
import { useSession, buildCase } from "../../lib/session";
import { investigationRows } from "../../lib/investigations";
import { TreatmentView } from "../TreatmentView";

export default function FinalStep({ scores }) {
  const { state, set, run, pending } = useSession();
  const loading = !!pending.final;
  const entered = investigationRows(state.investigations).length + Object.values(state.results).filter(Boolean).length;

  const generate = () => run("final", buildCase(state, scores, "final"), (r) => { set("final", r); set("doseEdits", {}); });

  return (
    <div>
      <StepHeader num={7} title="Final Diagnosis & Treatment" sub="Uses the full case: history, triage scores, examination and investigation reports." />
      <div className="border rounded-md bg-card p-5 flex flex-wrap items-center gap-4" data-testid="final-input-summary">
        <div className="text-sm"><b data-testid="investigations-entered-count">{entered}</b> investigation result(s) entered</div>
        <Button className="cc-btn ml-auto" data-testid="btn-generate-final" onClick={generate} disabled={loading}>
          {state.final ? "Regenerate" : "Generate"} final diagnosis & treatment
        </Button>
      </div>
      <div className="mt-8">
        {loading ? <AiLoader text="Formulating final diagnosis & evidence-based plan" /> : state.final && <TreatmentView f={state.final} />}
      </div>
      <NavButtons onBack={() => set("step", 5)} onNext={() => set("step", 7)} nextDisabled={!state.final || loading} nextLabel="Final report" />
    </div>
  );
}
